module.exports = __webpack_public_path__ + "img/square-gold-blank-large.9b3e957d.png";